import { render, staticRenderFns } from "./index.vue?vue&type=template&id=baa927d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=baa927d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa927d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa927d8')) {
      api.createRecord('baa927d8', component.options)
    } else {
      api.reload('baa927d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=baa927d8&scoped=true", function () {
      api.rerender('baa927d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/storeVersion/index.vue"
export default component.exports